<p class="font-bold line-height-2" i18n>Please enter your Home PLMN information specified as below.</p>

<rs-guidance-box class="mb-4" i18n>
  Guidance: The PLMN information is comprised of MCC+MNC and each PLMN entry is accompanied with a specific type of access technology (e.g.,
  GSM, UTRAN (3G UMTS), EUTRAN (4G), NG-RAN (5G)). If your home network supports more than one type of access technologies, please enter
  them as a separate entry in the order of priority. For example, the first entry is 311 123 w/ NG-RAN, the second entry is 311 123 w/
  E-UTRAN, and the third entry is 311 123 w/ UTRAN.
</rs-guidance-box>

<div class="ml-6">
  <rs-error-message *ngIf="errorFound" class="mb-3" [message]="errorMessage" />
  <div style="width: 750px">
    <p-table
      showGridlines="true"
      stripedRows="true"
      [value]="profileValues.homePLMNwithAcT"
      styleClass="p-datatable-striped p-datatable-gridlines"
    >
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 7rem" />
          <col />
          <col />
          <col />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th i18n>Record #</th>
          <th>
            <div i18n>Mobile Country Code</div>
            <div class="font-medium" i18n>(3-digit number)</div>
          </th>
          <th>
            <div i18n>Mobile Network Code</div>
            <div class="font-medium" i18n>(2 to 3-digit number)</div>
          </th>
          <th i18n>Access Technology</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-record let-rowIndex="rowIndex">
        <tr>
          <td style="text-align: center">{{ rowIndex + 1 }}</td>
          <td>
            <input
              pInputText
              rsNumbersOnlyInput
              class="maximize-inputs console-text"
              [maxlength]="3"
              [(ngModel)]="record.mobileCountryCode"
              (ngModelChange)="record.mobileCountryCode = convertToNull($event)"
              (input)="handleFormEvents()"
            />
          </td>
          <td>
            <input
              pInputText
              rsNumbersOnlyInput
              class="maximize-inputs console-text"
              [maxlength]="3"
              [(ngModel)]="record.mobileNetworkCode"
              (ngModelChange)="record.mobileNetworkCode = convertToNull($event)"
              (input)="handleFormEvents()"
            />
          </td>
          <td>
            <p-select
              styleClass="maximize-inputs"
              [options]="accessTechnologyOptions"
              [(ngModel)]="record.accessTechnology"
              dataKey="value"
              optionLabel="label"
              i18n-placeholder
              placeholder="Please Select:"
              appendTo="body"
              [showClear]="true"
              (onChange)="handleFormEvents()"
            ></p-select>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" i18n>No records defined.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
